import React from 'react';
import { Link } from 'react-router-dom';
import { Rocket, Sparkles, MessageCircle } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';

const Option = ({ to, icon: Icon, title, sub, testid, primary }) => (
  <Link to={to} data-testid={testid}
    className={`flex items-center gap-3 p-4 rounded-xl border transition-transform hover:-translate-y-0.5 ${primary ? 'border-[#1D4ED8] bg-blue-50' : 'border-slate-200 bg-white'}`}>
    <span className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${primary ? 'bg-[#1D4ED8] text-white' : 'bg-slate-100 text-slate-600'}`}><Icon size={18} /></span>
    <span><span className="block text-sm font-semibold text-[#0A0F1C]">{title}</span><span className="block text-xs text-slate-500">{sub}</span></span>
  </Link>
);

export const UpgradeOptions = () => (
  <div className="space-y-2">
    <Option primary to="/portal/programs#memberships" icon={Sparkles} title="All-Access · $47/month" sub="All 5 coaching tools, unlimited businesses" testid="upgrade-all-access" />
    <Option to="/portal/programs" icon={Rocket} title="Coaching programs from $997" sub="Coaching with David + every tool, unlimited businesses" testid="upgrade-programs" />
    <Option to="/portal/book" icon={MessageCircle} title="Talk to David first" sub="Free 20-minute call to find the right fit" testid="upgrade-talk" />
  </div>
);

export default function UpgradeNudge({ open, onOpenChange, limit = 1 }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-white" data-testid="upgrade-nudge">
        <DialogHeader>
          <DialogTitle>Ready for your next business?</DialogTitle>
          <DialogDescription>Your current plan covers {limit} business. Upgrade to build as many as you want.</DialogDescription>
        </DialogHeader>
        <UpgradeOptions />
      </DialogContent>
    </Dialog>
  );
}
